@if (countdown$()) {
  <svg class="sol-spinner-svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <g transform="rotate(-90 12 12)">
      @for (segment of segments$(); track segment.id) {
        <circle
          [class]="segment.segmentClass"
          cx="12"
          cy="12"
          r="9.25"
          stroke-width="2"
          [attr.pathLength]="ringLength"
          [attr.stroke-dasharray]="segment.dash"
          [attr.stroke-dashoffset]="segment.offset"
        />
      }
    </g>
  </svg>
} @else {
  <svg class="sol-spinner-svg sol-spinner-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle class="sol-spinner-track" cx="12" cy="12" r="9.25" stroke-width="1.5" />
    <circle
      class="sol-spinner-ink"
      cx="12"
      cy="12"
      r="9.25"
      stroke-width="1.5"
      stroke-linecap="round"
      pathLength="100"
      stroke-dasharray="25 100"
    />
  </svg>
}
